import {ErrorsRanked} from '../errors/ErrorsRanked'
import {ModeSettingEnum} from '@colonist/game-base-types'
import {GameModeDataController} from '@colonist/shared-types'
import {UserItems} from '../store/UserItems'
import {ABTestCategory} from '../ABTestTypes'

export const CK_FREE_GAME_COUNT = 3

export function userHasAccessToRankedCitiesAndKnights(userItems: UserItems | undefined, ckTotalGameCount: number | undefined, abTestGroups: Partial<Record<ABTestCategory, string>>, freePlayUntil: Date | undefined): boolean {
    if(userHasNormalAccessToCitiesAndKnights(userItems)) return true
    if(userHasFreeCitiesAndKnightsGame(abTestGroups, ckTotalGameCount)) return true
    if(userHasFreeGameFromDiceRoll(abTestGroups, freePlayUntil)) return true

    return false
}

export function userHasNormalAccessToCitiesAndKnights(userItems: UserItems | undefined): boolean {
    if(userItems == undefined) return false
    const citiesAndKnightsData = GameModeDataController.getModeDataForMode(ModeSettingEnum.CitiesAndKnights4P)
    if(citiesAndKnightsData == undefined) throw new ErrorsRanked.ServerErrorCitiesAndKnights()

    if(userItems.membership != undefined) return true
    if(userItems.hasAccessToPremiumMode(citiesAndKnightsData)) return true
    return false
}

export function userHasFreeCitiesAndKnightsGame(abTestGroups: Partial<Record<ABTestCategory, string>>, ckTotalGameCount: number | undefined): boolean {
    if(abTestGroups['CK_MONETIZATION'] != 'THREE_FREE_GAMES') return false
    if(ckTotalGameCount == undefined) return false
    if(ckTotalGameCount < CK_FREE_GAME_COUNT) return true
    return false
}

export function userHasFreeGameFromDiceRoll(abTestGroups: Partial<Record<ABTestCategory, string>>, freePlayUntil: Date | undefined): boolean {
    if(abTestGroups['CK_MONETIZATION'] != 'DAILY_DICE_ROLL') return false
    if(freePlayUntil == undefined) return false
    if(freePlayUntil.getTime() > Date.now()) return true
    return false
}
